import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["triggerRef"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import Button from '@atlaskit/button/standard-button';
import DropdownMenu, { DropdownItem, DropdownItemGroup } from '@atlaskit/dropdown-menu';
import ShowMoreHorizontalIcon from '@atlaskit/icon/core/show-more-horizontal';
import { N0, N400 } from '@atlaskit/theme/colors';
import { MenuItemClickedEvent, useAnalyticsEvents } from '@atlassian/mpac-analytics';
import { pluralize } from '@atlassian/mpac-utils';
import React, { useState } from 'react';
import { ANALYTICS_OBJECT_TYPE_APP_REQUESTS, ANALYTICS_SUBJECT_ID_REJECT_REQUEST } from '../../../../../analytics/Events';
import RejectRequestModal from './RejectRequestModal';
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
function AppRequestActions(props) {
  const fireAnalyticsEvent = useAnalyticsEvents();
  const [isActionsOpen, setActionOpenFlag] = useState(false);
  const [isRejectRequestModalOpen, setRejectRequestModalOpen] = useState(false);
  const onRejectClick = () => {
    fireAnalyticsEvent({
      eventType: MenuItemClickedEvent,
      actionSubjectId: ANALYTICS_SUBJECT_ID_REJECT_REQUEST,
      objectType: ANALYTICS_OBJECT_TYPE_APP_REQUESTS,
      objectId: props.appRequest.appDetails.appKey
    });
    setRejectRequestModalOpen(true);
  };
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [isRejectRequestModalOpen && /*#__PURE__*/_jsx(RejectRequestModal, {
      appKey: props.appRequest.appDetails.appKey,
      appName: props.appRequest.appDetails.name,
      appRequestDefaultParams: props.appRequestDefaultParams,
      closeModal: () => setRejectRequestModalOpen(false),
      requestCount: props.appRequest.requestCount,
      onReject: props.onReject,
      edition: props.appRequest.edition
    }), /*#__PURE__*/_jsx(DropdownMenu, {
      isOpen: isActionsOpen,
      onOpenChange: () => setActionOpenFlag(!isActionsOpen),
      trigger: _ref => {
        let {
            triggerRef
          } = _ref,
          triggerProps = _objectWithoutProperties(_ref, _excluded);
        return /*#__PURE__*/_jsx(Button, _objectSpread(_objectSpread({
          ref: triggerRef
        }, triggerProps), {}, {
          appearance: "subtle",
          isSelected: isActionsOpen,
          iconAfter: /*#__PURE__*/_jsx(ShowMoreHorizontalIcon, {
            label: "App request actions",
            color: isActionsOpen ? "var(--ds-icon-selected, ".concat(N0, ")") : "var(--ds-icon, ".concat(N400, ")")
          })
        }));
      },
      children: /*#__PURE__*/_jsx(DropdownItemGroup, {
        children: /*#__PURE__*/_jsx(DropdownItem, {
          onClick: onRejectClick,
          children: "Reject ".concat(pluralize('request', props.appRequest.requestCount))
        })
      })
    })]
  });
}
export default AppRequestActions;